import { createTheme } from '@material-ui/core/styles';
import JETLightPalette from './JETLightPalette.module.scss';
import JETDarkPalette from './JETDarkPalette.module.scss';
import JETVariables from './JETVariables.module.scss';
import { TypographyOptions } from '@material-ui/core/styles/createTypography';
import JETTypography from './JETTypography.module.scss';
import { fontValueParser } from '@src/shared/utils';
const fontJETSans = {
  fontFamily: 'JETSansDigital',
  fontWeight: 400,
  src: `url('https://d30v2pzvrfyzpo.cloudfront.net/fonts/JETSansDigital-Regular-optimised-extended.woff2') format("woff2"),
  url('https://d30v2pzvrfyzpo.cloudfront.net/fonts/JETSansDigital-Regular-optimised-extended.woff') format("woff");`,
};

const fontJETSansBold = {
  fontFamily: 'JETSansDigital',
  fontWeight: 700,
  src: `url("https://d30v2pzvrfyzpo.cloudfront.net/fonts/JETSansDigital-Bold-optimised-extended.woff2") format("woff2"), url("https://d30v2pzvrfyzpo.cloudfront.net/fonts/JETSansDigital-Bold-optimised-extended.woff") format("woff")`,
};

const fontJETSansExtraBold = {
  fontFamily: 'JETSansDigital',
  fontWeight: 800,
  src: `url("https://d30v2pzvrfyzpo.cloudfront.net/fonts/JETSansDigital-ExtraBold-optimised-extended.woff2") format("woff2"), url("https://d30v2pzvrfyzpo.cloudfront.net/fonts/JETSansDigital-ExtraBold-optimised-extended.woff") format("woff")`,
}


export const breakpointsValue = {
  values: {
    xs: 480,
    sm: 760,
    md: 1028,
    lg: 1280,
    xl: 1920,
  },
}



const JetMuiTypography: TypographyOptions = {
  fontFamily: 'JETSansDigital',
  jet: {
    regular: {
      ...fontJETSans
    },
    bold: {
      ...fontJETSansBold
    },
    extraBold: {
      ...fontJETSansExtraBold
    }
  },
  button:{
    buttonSSize : {...fontValueParser(JETTypography.buttonSSize)},
    buttonMSize : {...fontValueParser(JETTypography.buttonMSize)},
    buttonLSize : {...fontValueParser(JETTypography.buttonLSize)},
    buttonXsSize : {...fontValueParser(JETTypography.buttonXsSize)},
    buttonMWeight : JETTypography.buttonMWeight,
    buttonLWeight : JETTypography.buttonLWeight,
    buttonSWeight : JETTypography.buttonSWeight,
    buttonXsWeight : JETTypography.buttonXsWeight
  },
  body1: {
    ...fontJETSansBold,
    lineHeight: 1.3,
    ['&.body_bold']: {
      ...fontValueParser(JETTypography.bodyLSize),
      fontWeight: JETTypography.bodyStrongLWeight,
    },
    ['&.interactive_small']: {
      ...fontValueParser(JETTypography.bodyLSize),
      fontWeight: JETTypography.bodyStrongSWeight,
    },
    ['&.body_regular']: {
      ...fontValueParser(JETTypography.bodyLSize),
      fontWeight: JETTypography.bodySWeight,
    },
    ['&.body_small_regular']: {
      ...fontValueParser(JETTypography.bodySSize),
      fontWeight: JETTypography.bodySWeight,
    },
    ['&.body_small_bold']: {
      ...fontValueParser(JETTypography.bodySSize),
      fontWeight: JETTypography.bodyStrongSWeight,
    },
    ['&.body_large']: {
      ...fontValueParser(JETTypography.bodyLSize), // 16px
      fontWeight: JETTypography.bodyLWeight,
    },
    ['&.subheading_s']: {
      ...fontValueParser(JETTypography.SubheadingSSizeWide), // 20px
      fontWeight: JETTypography.SubheadingSWeight,
      // '@media only screen and (max-width:768px)': {
      //   fontSize: '16px',
      //   lineHeight: '24px',
      // }
    },
    ['&.subheading_s_n']: {
      ...fontValueParser(JETTypography.SubheadingSSizeNarrow), // 20px
      fontWeight: JETTypography.SubheadingSWeight,
      // '@media only screen and (max-width:768px)': {
      //   fontSize: '16px',
      //   lineHeight: '24px',
      // }
    },
    ['&.subheading_l']: {
      ...fontValueParser(JETTypography.SubheadingLSizeWide), // 20px
      fontWeight: JETTypography.SubheadingLWeight,
      // '@media only screen and (max-width:768px)': {
      //   fontSize: '16px',
      //   lineHeight: '24px',
      // }
    },
  },
  body2: {
    fontSize: '.750rem',
    lineHeight: '1rem',
  },
  subtitle1: {
    fontSize: '1.0625rem',
  },
  caption: {
    fontWeight: 400,
    lineHeight: 1.29,
    ['&.caption']: {
      ...fontValueParser(JETTypography.captionSize),
      fontWeight: JETTypography.captionWeight,
    },
    ['&.caption_link']:{
      ...fontValueParser(JETTypography.captionLinkSize),
      fontWeight: JETTypography.captionLinkWeight,
      textDecoration: 'underline',
      letterSpacing: 0
    },
    ['&.caption_bold']: {
      ...fontValueParser(JETTypography.captionStrongSize),
      fontWeight: JETTypography.captionStrongWeight,
      letterSpacing: 0
    },
    ['&.caption_bold_link']: {
      ...fontValueParser(JETTypography.captionStrongLinkSize),
      fontWeight: JETTypography.captionStrongLinkWeight,
      letterSpacing: 0
    }
  },
  h1: {
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: '1.25',
    ['&.heading_xxl']: {
      ...fontValueParser(JETTypography.headingXxlSizeWide),
      fontWeight: JETTypography.headingXxlWeight,
      '@media only screen and (max-width:768px)': {
        ...fontValueParser(JETTypography.headingXxlSizeNarrow),
      }
    }
  },
  h2: {
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: '2rem',
    ['&.heading_xl']: {
      ...fontValueParser(JETTypography.headingXlSizeWide),
      fontWeight: JETTypography.headingXlWeight,
      '@media only screen and (max-width:768px)': {
        ...fontValueParser(JETTypography.headingXlSizeNarrow),
      }
    }
  },
  h3: {
    ...fontJETSansBold,
    ['&.heading_l']: {
      ...fontValueParser(JETTypography.headingLSizeWide),
      fontWeight: JETTypography.headingLWeight,
      '@media only screen and (max-width:768px)': {
        ...fontValueParser(JETTypography.headingLSizeNarrow),
      }
    },
    ['&.heading_m']: {
      ...fontValueParser(JETTypography.headingMSizeWide),
      fontWeight: JETTypography.headingLWeight,
      '@media only screen and (max-width:768px)': {
        ...fontValueParser(JETTypography.headingMSizeNarrow),
      }
    }
  },
  h4: {
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: '1.25em',
    ['&.heading_m']: {
      ...fontValueParser(JETTypography.headingMSizeWide), // 24px
      fontWeight: JETTypography.headingMWeight,
      '@media only screen and (max-width:768px)': {
        ...fontValueParser(JETTypography.headingMSizeNarrow),
      }
    }
  },
  h5: {
    fontSize: '.875rem',
    fontWeight: 600,
    lineHeight: 1.29,
    ['&.heading_s']: {
      ...fontValueParser(JETTypography.headingSSizeWide),
      fontWeight: JETTypography.buttonSWeight,
      '@media only screen and (max-width:768px)': {
        ...fontValueParser(JETTypography.headingSSizeNarrow),
      }
    },
    ['&.heading_s_bold']: {
      ...fontValueParser(JETTypography.headingSSizeWide),
      lineHeight: 1.40,
      fontWeight: JETTypography.headingLWeight,
      '@media only screen and (max-width:768px)': {
        ...fontValueParser(JETTypography.headingSSizeNarrow),
      }
    }
  },
  h6: {
    fontFamily: '',
    fontSize: '.75rem',
    fontWeight: 700,
    lineHeight: 1.75,
  },
}


const JetThemeLight = createTheme({
  breakpoints: {
    ...breakpointsValue
  },
  palette: {
    jet: {
      ...JETLightPalette,
    },
    primary: {
      main: '#1574F5',
    },
  },
  typography: {
    ...JetMuiTypography
  },
  fonts: {
    jet: {
      regular: {
        ...fontJETSans
      },
      bold: {
        ...fontJETSansBold
      },
      extraBold: {
        ...fontJETSansExtraBold
      }
    },
  },
  content: {
    width: '100%',
    maxWidth: '1280px',
  },
  variables: {
    ...JETVariables
  },
  schema:{
    ...JETTypography
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [fontJETSans,fontJETSansBold,fontJETSansExtraBold],
        
      },
    },
    MuiCheckbox: {
      colorSecondary: {
        '&$checked': {
          color: JETLightPalette.interactiveBrand,
          fontSize: '14px',
        },
      },
    },
    MuiCircularProgress: {
      root: {
        '& .MuiCircularProgress-svg': {
          '& .MuiCircularProgress-circle': {
            strokeDasharray: '50px 200px'
          }
        }
      }
    },
    MuiTypography: {
      colorTextPrimary: {
        color: JETLightPalette.contentInverse
      }
    }
  }
});

const JetThemeDark = createTheme({
  palette: {
    jet: {
      ...JETDarkPalette
    }
  },
  typography: {
    ...JetMuiTypography,
  },
  fonts: {
    jet: {
      regular: {
        ...fontJETSans
      },
      bold: {
        ...fontJETSansBold
      },
      extraBold: {
        ...fontJETSansExtraBold
      }
    },
  },
  breakpoints: {
    ...breakpointsValue
  },
  variables: {
    ...JETVariables
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [fontJETSans,fontJETSansBold,fontJETSansExtraBold],
      },
    },
  },

})


const JETScooberTheme = createTheme({
  palette: {
    jet: {
      ...JETDarkPalette
    }
  },
  typography: {
    ...JetMuiTypography,
  },
  fonts: {
    jet: {
      regular: {
        ...fontJETSans
      },
      bold: {
        ...fontJETSansBold
      },
      extraBold: {
        ...fontJETSansExtraBold
      }
    },
  },
  breakpoints: {
    ...breakpointsValue
  },
  variables: {
    ...JETVariables
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [fontJETSans,fontJETSansBold,fontJETSansExtraBold],
      },
    },
  },

})


export { JetThemeLight, JetThemeDark,JETScooberTheme };
